// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1B-Qd","head":"Table_head__4TjUI","col":"Table_col__REwam"};